import { create } from "zustand";
import { devtools, persist } from "zustand/middleware";
import { produce } from "immer";

const initialState = {
  serverSuccess: {},
  serverError: {},

  sideBarCollapsed: false,
  drawerOpen: false,
};

const store = (set) => ({
  ...initialState,
  // actions
  serverRequest: () => {
    set(
      produce((state) => {
        state.serverSuccess = {};
        state.serverError = {};
      })
    );
  },
  setServerSuccess: (data) => {
    set(
      produce((state) => {
        state.serverSuccess = data;
        state.serverError = {};
      })
    );
  },
  setServerError: (error) => {
    set(
      produce((state) => {
        state.serverSuccess = {};
        state.serverError = error;
      })
    );
  },
  setSideBarCollapsed: (collapsed) => {
    set(
      produce((state) => {
        state.sideBarCollapsed = collapsed;
      })
    );
  },
  setDrawerOpen: (open) => {
    set(
      produce((state) => {
        state.drawerOpen = open;
      })
    );
  },
});

const storeName = "APP STORE";
const useAppStore = create(
  devtools(persist(store, { name: storeName }), { name: storeName })
);

export default useAppStore;
